<template>
  <div class="row">
    <card-projetos-andamento
      class="mt-4 col-12 col-md-3"
      ref="dashboard-andamento"
    />
    <card-projetos-encerrados
      class="mt-4 col-12 col-md-3"
      ref="dashboard-encerrado"
    />
    <card-saldo-projetos class="mt-4 col-12 col-md-3" ref="dashboard-saldo" />
    <card-faturamento
      class="mt-4 col-12 col-md-3"
      ref="dashboard-faturamento"
    />

    <div class="mt-4 col-12">
      <b-card no-body>
        <div class="mt-0 d-flex align-items-center justify-content-between">
          <h5>Despesas previstas x realizadas</h5>
          <input-select :options="projetos" v-model="projetoId" />
        </div>
        <hr />
        <grafico-executora ref="dashboard-grafico" />
      </b-card>
    </div>

    <div class="col-12 mt-4">
      <b-card no-body>
        <b-modal size="xl" id="bv-modal-filtro-projeto" hide-footer>
          <filtro
            ref="dashboard-filtro"
            @buscar="buscarProjetos"
            :filtro="filtroProjetos"
          />
        </b-modal>
        <div class="mt-1 d-flex align-items-center justify-content-between">
          <h5>Projetos</h5>
          <b-button @click="$bvModal.show('bv-modal-filtro-projeto')">
            <i class="fa-solid fa-filter mr-2"></i>
            Filtro
          </b-button>
        </div>
        <hr />
        <tabela ref="projetos" />
      </b-card>
    </div>
  </div>
</template>
<script>
import { DEFINIR_BREADCRUMB } from "@/store/breadcrumbs.module";

import CardFaturamento from "./components/cards_executora/CardFaturamento.vue";
import CardProjetosAndamento from "./components/cards_executora/CardProjetosAndamento.vue";
import CardProjetosEncerrados from "./components/cards_executora/CardProjetosEncerrados.vue";
import CardSaldoProjetos from "./components/cards_executora/CardSaldoProjetos.vue";
import GraficoExecutora from "./components/NewGraficoExecutora.vue";

import Tabela from "./components/TabelaExecutora";
import Filtro from "./components/Filtro";

import InputSelect from "@/components/inputs/InputSelect.vue";

import ProjetoService from "@/common/services/projeto/projeto.service";

export default {
  components: {
    CardFaturamento,
    CardProjetosAndamento,
    CardProjetosEncerrados,
    CardSaldoProjetos,
    GraficoExecutora,
    Tabela,
    Filtro,
    InputSelect,
  },
  data: () => ({
    filtroProjetos: {},
    projetos: [],
    projetoId: null,
  }),
  methods: {
    buscarProjetos: function (filtro) {
      this.filtroProjetos = filtro;
      this.$refs.projetos.buscar(filtro);
    },
    listarProjetos: function () {
      let endpoints = [
        "ProjetoEmpresaExecutoraCriadora",
        "ProjetoEmpresaExecutora",
      ];
      this.projetos = [
        {
          value: null,
          text: "Todos projetos",
        },
      ];
      endpoints.forEach((endpoint) => {
        ProjetoService.setEndpoint(endpoint);
        ProjetoService.listar(this.empresasSelecionada, "", 0, 0).then(
          (res) => {
            this.projetos.push(
              ...res.data.data.itens.map((el) => {
                return {
                  value: el.id,
                  text: `${el.projeto.codigo} | ${el.projeto.proposta.descricaoTecnica.apelido}`,
                };
              })
            );
          }
        );
      });
    },
  },
  mounted() {
    this.$store.dispatch(DEFINIR_BREADCRUMB, [{ titulo: "Dashboard" }]);

    this.listarProjetos();
  },
  computed: {
    empresasSelecionada: function () {
      if (!this.$store.state.app.selectedCompanyObj) return null;
      return this.$store.state.app.selectedCompanyObj.id;
    },
  },
  watch: {
    empresasSelecionada: function () {
      for (let ref in this.$refs) {
        this.$refs[ref].buscarDados(this.projetoId);
      }

      this.listarProjetos();
    },
    projetoId: function () {
      this.$refs["dashboard-grafico"].buscarDados(this.projetoId);
    },
  },
};
</script>
<style>
.card-img-absolute {
  position: absolute;
  top: 0;
  right: 0;
  height: 100%;
}
</style>